
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hcPI1", function(module, exports) {

$parcel$export(module.exports, "SidebarFiltersGlobal", () => $9c5d22e3447ed873$export$41d545c685d05a17);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1kQCU = parcelRequire("1kQCU");

var $96w9D = parcelRequire("96w9D");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $lGo7j = parcelRequire("lGo7j");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $gBXKh = parcelRequire("gBXKh");

var $koeKL = parcelRequire("koeKL");

var $gPKa5 = parcelRequire("gPKa5");
const $9c5d22e3447ed873$var$SidebarFiltersGlobalContent = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { queryReference: resourceQueryRef } = (0, $ao2h1.useRelayResource)((0, $96w9D.sidebarFiltersGlobalResource));
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $gBXKh.default), resourceQueryRef);
    const cloudId = (0, $koeKL.useCloudId)();
    const onFavouritesChanged = (0, $5uXOq.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        cloudId,
        loadQuery
    ]);
    return(// TODO: Change to React Suspense when it's supported in SSR.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "filters-global",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
            isFull: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPKa5.Menu), {
        queryReference: queryReference,
        onFavouritesChanged: onFavouritesChanged
    }), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).FILTERS_GLOBAL
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    })));
});
const $9c5d22e3447ed873$export$41d545c685d05a17 = ()=>{
    const [isNinGlobalScopeEnrolmentEnabled] = (0, $1kQCU.useGlobalScopeEnrolmentEnable)();
    if (isNinGlobalScopeEnrolmentEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9c5d22e3447ed873$var$SidebarFiltersGlobalContent, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    });
};

});
parcelRegister("1kQCU", function(module, exports) {

$parcel$export(module.exports, "useGlobalScopeOptOutFlow", () => $d96a4352cc61ecaf$export$f39dd0211cb78bcf);
$parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", () => $d96a4352cc61ecaf$export$f45d1a4e873cac44);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $VILOn = parcelRequire("VILOn");

var $7SHTM = parcelRequire("7SHTM");

var $bATyw = parcelRequire("bATyw");

var $bVDE5 = parcelRequire("bVDE5");

var $cZpsT = parcelRequire("cZpsT");

var $2YP9W = parcelRequire("2YP9W");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");

var $aK1ba = parcelRequire("aK1ba");

var $cnynt = parcelRequire("cnynt");
const $d96a4352cc61ecaf$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('', false);
const $d96a4352cc61ecaf$export$f39dd0211cb78bcf = (href)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const redirectToGin = (0, $5uXOq.useCallback)(()=>{
        if (href) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.assign(href);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        href
    ]);
    const { renderFeedbackDialog: renderFeedbackDialog } = (0, $aK1ba.default)({
        onClose: redirectToGin,
        isAdminSettingsModal: false
    });
    /**
	 * globalScopeOptOut
	 * Triggers the NIN Global Scope opt-out process, including all UI orchestration of feedback.
	 *
	 * The caller should handle "default" behaviour for when the user is already not enrolled,
	 * unless the `preventDefault` callback has been called. This allows for easy usage with links,
	 * where the onClick event's `preventDefault` can be passed.
	 *
	 * If using an event's `preventDefault`, remember to bind the event!
	 * ex: `globalScopeOptOut(event.preventDefault.bind(event));`
	 *
	 * @param {Function} preventDefault
	 */ return (0, $5uXOq.useCallback)(async (preventDefault)=>{
        // If the user has already opt-out, just allow the caller to handle the click
        if (!(0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
        // Otherwise, take over the interaction
        preventDefault && preventDefault();
        try {
            // Update user preference and local storage
            !isAnonymous && await (0, $7SHTM.setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
            (0, $VILOn.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
            renderFeedbackDialog();
            if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $d96a4352cc61ecaf$var$sessionStorageProvider.set('showGinOptOutFlag', 'true');
            else sessionStorage.setItem('showGinOptOutFlag', 'true');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            showFlag({
                type: 'error',
                title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cnynt.default).errorOptOutTitleIssueTermRefresh : (0, $cnynt.default).errorOptOutTitle,
                description: (0, $cnynt.default).errorOptOutDesc,
                testId: 'issue-navigator-action-meatball-menu.ui.error-flag',
                messageId: 'issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.show-flag.error',
                messageType: 'transactional'
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'optOutOfNin',
                    packageName: 'jiraIssueNavigatorChangeboarding',
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
        }
    }, [
        isAnonymous,
        renderFeedbackDialog,
        showFlag
    ]);
};
const $d96a4352cc61ecaf$export$f45d1a4e873cac44 = ()=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.
    const [localStorageData] = (0, $5uXOq.useState)((0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
    const { data: resourceData } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    const [{ isInitialRender: isInitialRender }] = (0, $bVDE5.useSpaStateTransition)();
    // We assume NIN global scope is enabled if this is an initial render, otherwise we rely on localStorageData if it
    // exists, otherwise we use resourceData. resourceData is async, and can block for a long time, so we optimise for
    // speed rather than correctness by trusting localStorageData.
    let isNinGlobalScopeEnrolmentEnabled;
    if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
    else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = resourceData;
    return [
        isNinGlobalScopeEnrolmentEnabled,
        resourceData
    ];
};

});
parcelRegister("VILOn", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $5dc42c779a970b72$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $5dc42c779a970b72$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $5dc42c779a970b72$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $5dc42c779a970b72$export$458eda2352a1e223);

var $bSSG7 = parcelRequire("bSSG7");

var $2YZCu = parcelRequire("2YZCu");
const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, $bSSG7.createLocalStorageProvider)('nin-changeboarding');
const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $5dc42c779a970b72$export$34434fbbe40a8047();
    }
};
const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("7SHTM", function(module, exports) {

$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", () => $a1fa570fc83fd392$export$2fc59b10f256dbee);
$parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", () => $a1fa570fc83fd392$export$89f09c81b642e3c7);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
const $a1fa570fc83fd392$var$setGlobalScopeUserPreference = async (input)=>{
    const result = await (0, $eusud.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
            variables: {
                input: input
            }
        })
    });
    if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
        cause: result.errors?.[0]
    });
};
const $a1fa570fc83fd392$export$2fc59b10f256dbee = async (value)=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment',
        value: value ? 'nin' : 'gin'
    });
const $a1fa570fc83fd392$export$89f09c81b642e3c7 = async ()=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
        key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
        value: false
    }).catch((error)=>(0, $jcw0u.default)({
            meta: {
                id: 'resetGlobalScopeGinFlag',
                packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        }));

});

parcelRegister("bATyw", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $a818348721ae6866$export$3f6390b4131d761b);

var $2M1hQ = parcelRequire("2M1hQ");

const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("jyZ5j"));
const $a818348721ae6866$export$3f6390b4131d761b = (0, $2M1hQ.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $a818348721ae6866$var$getDataLoader
});

});
parcelRegister("jyZ5j", function(module, exports) {

let $e3e0936d37a0ceb5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3e0936d37a0ceb5$var$load("7etJl").then(()=>parcelRequire('dIecw'));

});


parcelRegister("bVDE5", function(module, exports) {

$parcel$export(module.exports, "useSpaStateTransition", () => $1f866bb77da3c907$export$4d1974344641a2c9);
$parcel$export(module.exports, "default", () => $1f866bb77da3c907$export$2e2bcd8739ae039);

var $6RCeq = parcelRequire("6RCeq");

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $7w9eZ = parcelRequire("7w9eZ");
const $1f866bb77da3c907$var$getNavigationStart = ()=>{
    // @ts-expect-error - TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'. | TS2339 - Property 'timing' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    const timestamp = (0, $6RCeq.default) && (0, $6RCeq.default).timing && (0, $6RCeq.default).timing.navigationStart;
    return timestamp ? new Date(timestamp).toISOString() : undefined;
};
const $1f866bb77da3c907$var$getLastTransition = (currentPage, visitedPages)=>{
    if (visitedPages.length === 0) return undefined;
    const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
    const appNamesToStr = (appNames)=>appNames.join('+') || '?';
    const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
    const currPage = appNamesToStr(collectAppNames(currentPage));
    return `${prevPage} > ${currPage}`;
};
const $1f866bb77da3c907$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
    // If there are no previously visited pages the transition didn't have a place
    if (visitedPages.length === 0) return undefined;
    return currentPage.startTime;
};
const $1f866bb77da3c907$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
        isInitialRender: visitedPages.length === 0,
        transitionsCount: visitedPages.length,
        lastTransition: $1f866bb77da3c907$var$getLastTransition(currentPage, visitedPages),
        lastTransitionStartTime: $1f866bb77da3c907$var$getLastTransitionStartTime(currentPage, visitedPages),
        navigationStart: $1f866bb77da3c907$var$getNavigationStart(),
        currentPageId: currentPage.uuid
    });
// @ts-expect-error - TS2322 - Type 'SubscriberComponent<TransitionState, BoundActions<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/controllers/spa-state/src/actions/index")>, Record<...>>' is not assignable to type 'Subscriber'.
const $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber = (0, $51nlc.createSubscriber)((0, $7w9eZ.default), {
    displayName: 'SpaStateTransitionStateSubscriber',
    selector: $1f866bb77da3c907$export$aea217a45095ce11
});
const $1f866bb77da3c907$export$4d1974344641a2c9 = (0, $3sQ5x.createHook)((0, $7w9eZ.default), {
    selector: $1f866bb77da3c907$export$aea217a45095ce11
});
var $1f866bb77da3c907$export$2e2bcd8739ae039 = $1f866bb77da3c907$var$SpaStateTransitionStateSubscriber;

});

parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("aK1ba", function(module, exports) {

$parcel$export(module.exports, "default", () => $106d1fc5065910b3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $bw7Gm = parcelRequire("bw7Gm");

var $4DPZY = parcelRequire("4DPZY");

var $9OXo1 = parcelRequire("9OXo1");

var $g7SDw = parcelRequire("g7SDw");
const $106d1fc5065910b3$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
const $106d1fc5065910b3$var$unknownAttributeValue = 'unknown';
const $106d1fc5065910b3$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
        {
            id: (0, $7iULw.EntryKeys).LOCATION,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? (0, $bw7Gm.default)(globalThis.location?.href) : (0, $bw7Gm.default)(window.location.href) // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).REFERER,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            value: document.referrer ? (0, $bw7Gm.default)(document.referrer) : ''
        },
        {
            id: (0, $7iULw.EntryKeys).USER_AGENT,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? globalThis.navigator?.userAgent : navigator.userAgent // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).SCREEN_RESOLUTION,
            value: (0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? `${globalThis.window?.screen?.width} x ${globalThis.window?.screen?.height}` : `${window.screen.width} x ${window.screen.height}` // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_NAME,
            value: routeName
        },
        {
            id: (0, $7iULw.EntryKeys).ROUTE_GROUP,
            value: routeGroup
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: isProjectSimplified.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: 'cloud-id',
            value: cloudId
        }
    ];
const $106d1fc5065910b3$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const titleDetails = isAdminSettingsModal ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).titleDetailsAdminIssueTermRefresh : (0, $g7SDw.default).titleDetailsAdmin) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).titleDetailsUserIssueTermRefresh : (0, $g7SDw.default).titleDetailsUser);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, titleDetails));
};
const $106d1fc5065910b3$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const [{ data: projectData }] = (0, $4DPZY.useContainerContext)();
    const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $9OXo1.useTenantContext)();
    const routeGroup = route.group ?? $106d1fc5065910b3$var$unknownAttributeValue;
    const routeName = route.name ?? $106d1fc5065910b3$var$unknownAttributeValue;
    let projectType = $106d1fc5065910b3$var$unknownAttributeValue;
    let isProjectSimplified = false;
    if (projectData && 'project' in projectData && projectData.project) {
        projectType = projectData.project.type;
        isProjectSimplified = projectData.project.isSimplified;
    }
    const renderFeedbackDialog = (0, $5uXOq.useCallback)(()=>{
        openFeedbackCollector({
            feedbackGroupId: $106d1fc5065910b3$export$3fe286306fb8ddfb,
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
            onClose: onClose,
            feedbackContext: $106d1fc5065910b3$export$b028e515f8f652e0({
                isSiteAdmin: isSiteAdmin,
                cloudId: cloudId,
                routeGroup: routeGroup,
                routeName: routeName,
                projectType: projectType,
                isProjectSimplified: isProjectSimplified
            }),
            feedbackTitle: formatMessage((0, $g7SDw.default).title),
            feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($106d1fc5065910b3$export$3a73a4e2115ebf73, {
                isAdminSettingsModal: isAdminSettingsModal
            }),
            selectLabel: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $g7SDw.default).reasonTitleIssueTermRefresh : (0, $g7SDw.default).reasonTitle),
            // Intentional whitespace to clear the placeholder
            // (eluding feedback dialog's empty check for this prop, which includes empty string)
            summaryPlaceholder: ' ',
            submitButtonLabel: formatMessage((0, $g7SDw.default).submitCaption),
            cancelButtonLabel: formatMessage((0, $g7SDw.default).cancelCaption),
            feedbackGroupLabels: {
                empty: {
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonPlaceholder)
                },
                bug: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonBug)
                },
                comment: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonSpeed)
                },
                suggestion: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonOthers)
                },
                question: {
                    fieldLabel: formatMessage((0, $g7SDw.default).reasonQuestion),
                    selectOptionLabel: formatMessage((0, $g7SDw.default).reasonParity)
                }
            }
        });
    }, [
        openFeedbackCollector,
        onClose,
        isSiteAdmin,
        cloudId,
        routeGroup,
        routeName,
        projectType,
        isProjectSimplified,
        formatMessage,
        isAdminSettingsModal
    ]);
    return {
        renderFeedbackDialog: renderFeedbackDialog
    };
};
var $106d1fc5065910b3$export$2e2bcd8739ae039 = $106d1fc5065910b3$var$useFeedbackDialog;
const $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.050'
});

});
parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});


parcelRegister("g7SDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa18157d389278a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $5fa18157d389278a$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
        "defaultMessage": "Let us know why you're moving"
    },
    titleDetailsAdmin: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
        "defaultMessage": "You and your users will be able to use the old issue search temporarily."
    },
    titleDetailsUser: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
        "defaultMessage": "You'll be able to use the old issue search temporarily."
    },
    submitCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
        "defaultMessage": "Send feedback"
    },
    cancelCaption: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
        "defaultMessage": "Skip"
    },
    reasonTitle: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
        "defaultMessage": "What is your reason to go back to the old issue search?"
    },
    reasonPlaceholder: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
        "defaultMessage": "Select an option"
    },
    reasonParity: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
        "defaultMessage": "Features are missing"
    },
    reasonSpeed: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
        "defaultMessage": "It's slow"
    },
    reasonBug: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
        "defaultMessage": "There's a bug"
    },
    reasonOthers: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
        "defaultMessage": "Others"
    },
    reasonQuestion: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
        "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
    },
    titleDetailsAdminIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
    },
    titleDetailsUserIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh",
        "defaultMessage": "You'll be able to use the old way to search for work items temporarily."
    },
    reasonTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh",
        "defaultMessage": "What's the reason you're going back to the old way to searching for work items?"
    }
});
var $5fa18157d389278a$export$2e2bcd8739ae039 = $5fa18157d389278a$var$messages;

});


parcelRegister("cnynt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37d0c1deb4d01ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c37d0c1deb4d01ea$var$messages = (0, $7VHMR.defineMessages)({
    errorOptOutTitle: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
        "defaultMessage": "We couldn't switch to the old issue search"
    },
    errorOptOutDesc: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
        "defaultMessage": "Refresh and try again."
    },
    errorOptOutTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh",
        "defaultMessage": "We couldn't switch to the old search"
    }
});
var $c37d0c1deb4d01ea$export$2e2bcd8739ae039 = $c37d0c1deb4d01ea$var$messages;

});


parcelRegister("96w9D", function(module, exports) {

$parcel$export(module.exports, "sidebarFiltersGlobalResource", () => $4afb52221e3a3f09$export$7e0b804085f0470d);

var $ao2h1 = parcelRequire("ao2h1");

var $gBXKh = parcelRequire("gBXKh");

var $6YG83 = parcelRequire("6YG83");
const $4afb52221e3a3f09$export$7e0b804085f0470d = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $gBXKh.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("gBXKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0f1ab872360a786$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4654bfdfd3e20081cf96674156c0485e>>
 * @relayHash b167c3924c240111eb2c04f5138be112
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0

var $7vXy9 = parcelRequire("7vXy9");
const $a0f1ab872360a786$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v6 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ],
        "type": "JiraCustomFilter"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            },
                            {
                                "args": v2 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "isFavourite",
                                    "value": false
                                }
                            ],
                            "concreteType": "JiraSystemFilterConnection",
                            "kind": "LinkedField",
                            "name": "systemFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSystemFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSystemFilter",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ],
                                                    "type": "JiraFilter",
                                                    "abstractKey": "__isJiraFilter"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "favouriteFilters",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "filter",
                                            "value": {
                                                "sort": {
                                                    "order": "DESC"
                                                },
                                                "type": "FILTER"
                                            }
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 15
                                        }
                                    ],
                                    "concreteType": "JiraFavouriteConnection",
                                    "kind": "LinkedField",
                                    "name": "favourites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFavouriteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "JiraFilter",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v4 /*: any*/ 
                                                            ],
                                                            "type": "Node",
                                                            "abstractKey": "__isNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "favouriteFiltersOld",
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraFilterConnection",
                                    "kind": "LinkedField",
                                    "name": "favouriteFilters",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFilterEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isJiraFilter"
                                                        },
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "488e4e7ceb05d5d63726635de6bb578e2d4b52a4643ab9ca4393d1579b8d07f0",
            "metadata": {},
            "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider": (0, $7vXy9.default)
            }
        }
    };
}();
$a0f1ab872360a786$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
var $a0f1ab872360a786$export$2e2bcd8739ae039 = $a0f1ab872360a786$var$node;

});
parcelRegister("7vXy9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac90445fe2bfbc0$export$2e2bcd8739ae039);

var $4R6GH = parcelRequire("4R6GH");
var $3ac90445fe2bfbc0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $4R6GH.fg)('add_limit_to_nav3_starred_filter_sidebar');
    }
};

});



parcelRegister("fobme", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $4b9be639c0c7f77b$export$adf978edbdfaf080);
const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("gPKa5", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $ea420970049b7596$export$d9b273488cd8ce6f);

var $gBXKh = parcelRequire("gBXKh");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $kzjuk = parcelRequire("kzjuk");
var $g2EiV = parcelRequire("g2EiV");
var $gjTBi = parcelRequire("gjTBi");
var $gZEU1 = parcelRequire("gZEU1");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $8Jljs = parcelRequire("8Jljs");

var $3OGaE = parcelRequire("3OGaE");

var $juTur = parcelRequire("juTur");

var $lODMY = parcelRequire("lODMY");


var $STfki = parcelRequire("STfki");

var $5lItr = parcelRequire("5lItr");
const $ea420970049b7596$var$analyticsAttributes = {
    menu: {
        navigatorScope: 'global'
    },
    searchIssues: {
        itemId: 'search-issues'
    },
    viewAllFilters: {
        itemId: 'view-all-filters'
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ea420970049b7596$var$searchIssuesSelectedOn = (currentLocation)=>'jql' in currentLocation.query && !currentLocation.query.filter || Boolean(currentLocation.pathname.match(/\/issues(\/|\/([A-Z]+)-(\d+))?$/i)) && !currentLocation.query.jql && !currentLocation.query.filter;
const $ea420970049b7596$var$sectionCustomCssExperiment = {
    "&&& > div > div[data-ds--menu--heading-item='true']": {
        // TODO Delete this comment after verifying space token -> previous value `'6px'`
        paddingLeft: "var(--ds-space-075, 6px)",
        color: "var(--ds-text, #172B4D)"
    }
};
const $ea420970049b7596$var$topMarginCustomCssExperiment = {
    '> div[data-section="true"]': {
        marginTop: "var(--ds-space-negative-075, -6px)"
    }
};
const $ea420970049b7596$export$d9b273488cd8ce6f = ({ queryReference: queryReference, onFavouritesChanged: onFavouritesChanged })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isIssueNavigatorSSRPlaceholderEnabled = (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $lODMY.useIsActiveRoute)('global-issue-navigator');
    const isIssueViewSSRPlaceholderEnabled = (0, $lODMY.useIsActiveRoute)('issue') && (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nav_for_iv');
    const isSSRPlaceholderEnabled = isIssueNavigatorSSRPlaceholderEnabled || isIssueViewSSRPlaceholderEnabled;
    const data = (0, $8Uumt.usePreloadedQuery)((0, $gBXKh.default), queryReference);
    const systemFiltersSection = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1xlv12x7 _1rqn1fxt"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5lItr.SystemFiltersSection), {
            baseHref: "/issues/",
            jiraQuery: data.jira
        })), [
        data.jira
    ]);
    const starredFiltersList = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1xlv12x7 _1rqn1fxt _nh8j196n"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Jljs.StarredFiltersList), {
            baseHref: "/issues/",
            jiraQuery: data.jira,
            onFavouritesChanged: onFavouritesChanged
        })), [
        data.jira,
        onFavouritesChanged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $8218752389ec6194$export$d4cd258d01c03112),
        attributes: $ea420970049b7596$var$analyticsAttributes.menu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gZEU1.default), {
        label: "",
        isServer: false,
        isSSRPlaceholderEnabled: isSSRPlaceholderEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g2EiV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, formatMessage((0, $STfki.messages).filtersHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kzjuk.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: $ea420970049b7596$var$analyticsAttributes.searchIssues,
        selectedOn: $ea420970049b7596$var$searchIssuesSelectedOn,
        href: "/issues/?jql=order+by+created+DESC"
    }, formatMessage((0, $STfki.messages).newSearch))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea420970049b7596$var$DividerLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, systemFiltersSection, starredFiltersList), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjTBi.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: $ea420970049b7596$var$analyticsAttributes.viewAllFilters,
        href: "/jira/filters"
    }, formatMessage((0, $STfki.messages).viewAllFilters))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ea420970049b7596$var$DividerLine = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kzjuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdf97ddffeccb81$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cw1vL = parcelRequire("cw1vL");

var $j9VTE = parcelRequire("j9VTE");
const $dfdf97ddffeccb81$var$outerContainerCSS = null;
const $dfdf97ddffeccb81$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $dfdf97ddffeccb81$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $dfdf97ddffeccb81$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    const scrollbar = (0, $cw1vL.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $dfdf97ddffeccb81$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $dfdf97ddffeccb81$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $dfdf97ddffeccb81$var$containerCSS.basic,
                    showTopScrollIndicator && $dfdf97ddffeccb81$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $dfdf97ddffeccb81$export$2e2bcd8739ae039 = $dfdf97ddffeccb81$var$NavigationContent;

});
parcelRegister("cw1vL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a03f8a420074f68d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $a03f8a420074f68d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("g2EiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d4c6f37fa43791$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $f8d4c6f37fa43791$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $f8d4c6f37fa43791$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $f8d4c6f37fa43791$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $f8d4c6f37fa43791$export$2e2bcd8739ae039 = $f8d4c6f37fa43791$var$NavigationHeader;

});

parcelRegister("gZEU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2dd47d2fa741f7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $j7LBE = parcelRequire("j7LBE");
const $eb2dd47d2fa741f7$var$sidebarMinWidth = '240px';
const $eb2dd47d2fa741f7$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $eb2dd47d2fa741f7$var$SideNavigation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $eb2dd47d2fa741f7$export$2e2bcd8739ae039 = $eb2dd47d2fa741f7$var$SideNavigation;

});

parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $jSfqD = parcelRequire("jSfqD");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jSfqD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e63733262ea805c$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1aogK = parcelRequire("1aogK");

var $j9VTE = parcelRequire("j9VTE");
const $0e63733262ea805c$var$styles = {
    root: "_2rko1sit _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $0e63733262ea805c$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $j9VTE.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1aogK.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $0e63733262ea805c$var$styles.root,
            props.isSelected && $0e63733262ea805c$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $0e63733262ea805c$export$2e2bcd8739ae039 = $0e63733262ea805c$var$CustomItem;

});

parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("8Jljs", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersList", () => $0208f837fc89d8ec$export$b7f4b26a8737eee0);

var $47bDC = parcelRequire("47bDC");

var $jUReQ = parcelRequire("jUReQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $b2GBS = parcelRequire("b2GBS");

var $kZDjT = parcelRequire("kZDjT");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4ABV3 = parcelRequire("4ABV3");
const $0208f837fc89d8ec$export$1f869c99ead9db5f = 15;
const $0208f837fc89d8ec$var$VIEW_ALL_STARRED_FILTERS_HREF = '/jira/filters?page=1&sortKey=favourite&sortOrder=DESC';
const $0208f837fc89d8ec$var$analyticsPayload = {
    itemId: 'nin-view-all-starred-filters'
};
var $0208f837fc89d8ec$var$_StyledSection = /*#__PURE__*/ (0, $47bDC.default)((0, $gjTBi.default)).withConfig({
    componentId: "sc-8ugvpc-0"
})`${(p)=>p._css}`;
const $0208f837fc89d8ec$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $jUReQ.default), jiraQuery);
    (0, $b2GBS.useFavoritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
        // refresh when transitioning from pending to NOT pending
        if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
    });
    const starredFilterEdges = (0, $4R6GH.fg)('add_limit_to_nav3_starred_filter_sidebar') ? data.favouriteFilters?.edges?.filter(Boolean).filter((edge)=>!!edge?.node?.filterId).slice(0, $0208f837fc89d8ec$export$1f869c99ead9db5f) ?? [] : data.favouriteFiltersOld?.edges || [];
    if (!starredFilterEdges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0208f837fc89d8ec$var$_StyledSection, {
        title: formatMessage((0, $4ABV3.messages).newStarredFiltersHeader),
        _css: sectionCustomCss
    }, starredFilterEdges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZDjT.FilterItem), {
            key: edge.node.filterId,
            baseHref: baseHref,
            filter: edge.node,
            customAnalytics: {
                isStarred: true
            }
        }) : null), (0, $4R6GH.fg)('add_limit_to_nav3_starred_filter_sidebar') && (data.favouriteFilters?.pageInfo?.hasNextPage || (data.favouriteFilters?.edges ?? []).length > $0208f837fc89d8ec$export$1f869c99ead9db5f) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: $0208f837fc89d8ec$var$analyticsPayload,
        href: $0208f837fc89d8ec$var$VIEW_ALL_STARRED_FILTERS_HREF
    }, formatMessage((0, $4ABV3.messages).viewAllStarredFilters)));
};

});
parcelRegister("jUReQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9363fe5268fd6910$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb56e1e6bcabd6407e4fcb2c88f43e6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9363fe5268fd6910$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "filterId"
    }, v2 = {
        "kind": "FragmentSpread",
        "name": "filterItem_navigationAppsSidebarCommon"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "starredFiltersList_navigationAppsSidebarCommon",
        "selections": [
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "favouriteFilters",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": {
                                    "sort": {
                                        "order": "DESC"
                                    },
                                    "type": "FILTER"
                                }
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 15
                            }
                        ],
                        "concreteType": "JiraFavouriteConnection",
                        "kind": "LinkedField",
                        "name": "favourites",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraFavouriteEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v1 /*: any*/ ,
                                                    v2 /*: any*/ 
                                                ],
                                                "type": "JiraFilter",
                                                "abstractKey": "__isJiraFilter"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasNextPage"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisaddlimittonav3starredfiltersidebarenabledrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "alias": "favouriteFiltersOld",
                        "args": [
                            v0 /*: any*/ 
                        ],
                        "concreteType": "JiraFilterConnection",
                        "kind": "LinkedField",
                        "name": "favouriteFilters",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraFilterEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$9363fe5268fd6910$var$node.hash = "900a854eaff0335a83067c20ea0c3e72";
var $9363fe5268fd6910$export$2e2bcd8739ae039 = $9363fe5268fd6910$var$node;

});

parcelRegister("b2GBS", function(module, exports) {

$parcel$export(module.exports, "useFavoritesChangeEffect", () => $0fca8b6d7b43f931$export$659f59218fc5dd14);

var $5uXOq = parcelRequire("5uXOq");

var $4f8Oj = parcelRequire("4f8Oj");

var $4041n = parcelRequire("4041n");

var $1XJ20 = parcelRequire("1XJ20");
const $0fca8b6d7b43f931$export$659f59218fc5dd14 = (type, effect)=>{
    const { items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
    const typeItems = items[type];
    const pendingChanges = (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(typeItems, (item)=>item.pending);
    const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
    const previousHasPendingChanges = (0, $1XJ20.usePreviousWithInitial)(hasPendingChanges);
    (0, $5uXOq.useEffect)(()=>{
        effect(hasPendingChanges, previousHasPendingChanges);
    }, [
        effect,
        hasPendingChanges,
        previousHasPendingChanges
    ]);
};

});
parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $iJZ8l = parcelRequire("iJZ8l");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $iJZ8l.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $iJZ8l.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $9AmTW = parcelRequire("9AmTW");

var $6BtlL = parcelRequire("6BtlL");

var $kwbhb = parcelRequire("kwbhb");

var $6oLWS = parcelRequire("6oLWS");

var $aSWXp = parcelRequire("aSWXp");

var $kV9ss = parcelRequire("kV9ss");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $kV9ss.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $6oLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $kwbhb.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $aSWXp.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $6BtlL.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $9AmTW.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});
parcelRegister("9AmTW", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAri", () => $6fa93d978dc51edc$export$555c8ae00f64ebff);

var $IfwMb = parcelRequire("IfwMb");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-servicedesk/queue/manifest.ts
var $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $IfwMb.JiraServicedeskQueueAriResourceOwner),
    resourceType: (0, $IfwMb.JiraServicedeskQueueAriResourceType),
    resourceIdSlug: "activation/{activationId}/{queueId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        queueId: /[0-9]+/
    }
};
// src/jira-servicedesk/queue/index.ts
var $6fa93d978dc51edc$export$555c8ae00f64ebff = class _JiraServicedeskQueueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._queueId = opts.resourceIdSegmentValues.queueId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get queueId() {
        return this._queueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.qualifier,
            platformQualifier: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceOwner,
            resourceType: $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.queueId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                queueId: opts.queueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $6fa93d978dc51edc$var$jiraServicedeskQueueAriStaticOpts);
        return new _JiraServicedeskQueueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            queueId: this.queueId
        };
    }
};

});
parcelRegister("IfwMb", function(module, exports) {

$parcel$export(module.exports, "JiraServicedeskQueueAriResourceOwner", () => $085027a493012871$export$704112eeb385ceab);
$parcel$export(module.exports, "JiraServicedeskQueueAriResourceType", () => $085027a493012871$export$6adb8c07b8bc2c5a);
// src/jira-servicedesk/queue/types.ts
var $085027a493012871$export$704112eeb385ceab = "jira-servicedesk", $085027a493012871$export$6adb8c07b8bc2c5a = "queue";

});


parcelRegister("6BtlL", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAri", () => $4cecf7137216f798$export$fcd404066e55a7a8);

var $8ANGM = parcelRequire("8ANGM");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira-software/board/manifest.ts
var $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $8ANGM.JiraSoftwareBoardAriResourceOwner),
    resourceType: (0, $8ANGM.JiraSoftwareBoardAriResourceType),
    resourceIdSlug: "{boardId}",
    resourceIdSegmentFormats: {
        boardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-software/board/index.ts
var $4cecf7137216f798$export$fcd404066e55a7a8 = class _JiraSoftwareBoardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._boardId = opts.resourceIdSegmentValues.boardId;
    }
    get siteId() {
        return this._siteId;
    }
    get boardId() {
        return this._boardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.qualifier,
            platformQualifier: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceOwner,
            resourceType: $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts.resourceType,
            resourceId: `${opts.boardId}`,
            resourceIdSegmentValues: {
                boardId: opts.boardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $4cecf7137216f798$var$jiraSoftwareBoardAriStaticOpts);
        return new _JiraSoftwareBoardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            boardId: this.boardId
        };
    }
};

});
parcelRegister("8ANGM", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareBoardAriResourceOwner", () => $64183abbeecc9672$export$d716ba4f5572ec86);
$parcel$export(module.exports, "JiraSoftwareBoardAriResourceType", () => $64183abbeecc9672$export$d4b70c04cf2221a5);
// src/jira-software/board/types.ts
var $64183abbeecc9672$export$d716ba4f5572ec86 = "jira-software", $64183abbeecc9672$export$d4b70c04cf2221a5 = "board";

});


parcelRegister("kwbhb", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAri", () => $eeff8afd95fca51f$export$b7d4016f0f5da5b8);

var $6H9w3 = parcelRequire("6H9w3");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/dashboard/manifest.ts
var $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6H9w3.JiraDashboardAriResourceOwner),
    resourceType: (0, $6H9w3.JiraDashboardAriResourceType),
    resourceIdSlug: "activation/{activationId}/{dashboardId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        dashboardId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/dashboard/index.ts
var $eeff8afd95fca51f$export$b7d4016f0f5da5b8 = class _JiraDashboardAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._dashboardId = opts.resourceIdSegmentValues.dashboardId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get dashboardId() {
        return this._dashboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.qualifier,
            platformQualifier: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceOwner,
            resourceType: $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.dashboardId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                dashboardId: opts.dashboardId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $eeff8afd95fca51f$var$jiraDashboardAriStaticOpts);
        return new _JiraDashboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            dashboardId: this.dashboardId
        };
    }
};

});
parcelRegister("6H9w3", function(module, exports) {

$parcel$export(module.exports, "JiraDashboardAriResourceOwner", () => $014208d660d71eea$export$62c1deae25c41d24);
$parcel$export(module.exports, "JiraDashboardAriResourceType", () => $014208d660d71eea$export$e4e3a57a5e435aff);
// src/jira/dashboard/types.ts
var $014208d660d71eea$export$62c1deae25c41d24 = "jira", $014208d660d71eea$export$e4e3a57a5e435aff = "dashboard";

});


parcelRegister("aSWXp", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAri", () => $7eccae3426beb5b5$export$6d2eb3641569f26);

var $fi2nK = parcelRequire("fi2nK");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/plan/manifest.ts
var $7eccae3426beb5b5$var$jiraPlanAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fi2nK.JiraPlanAriResourceOwner),
    resourceType: (0, $fi2nK.JiraPlanAriResourceType),
    resourceIdSlug: "activation/{activationId}/{planId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        planId: /[0-9]+/
    }
};
// src/jira/plan/index.ts
var $7eccae3426beb5b5$export$6d2eb3641569f26 = class _JiraPlanAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._planId = opts.resourceIdSegmentValues.planId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get planId() {
        return this._planId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.qualifier,
            platformQualifier: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceOwner,
            resourceType: $7eccae3426beb5b5$var$jiraPlanAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.planId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                planId: opts.planId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $7eccae3426beb5b5$var$jiraPlanAriStaticOpts);
        return new _JiraPlanAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            planId: this.planId
        };
    }
};

});
parcelRegister("fi2nK", function(module, exports) {

$parcel$export(module.exports, "JiraPlanAriResourceOwner", () => $b21a627cc548ba69$export$bfd26af3c5e1b90d);
$parcel$export(module.exports, "JiraPlanAriResourceType", () => $b21a627cc548ba69$export$d6abe08eb30f433d);
// src/jira/plan/types.ts
var $b21a627cc548ba69$export$bfd26af3c5e1b90d = "jira", $b21a627cc548ba69$export$d6abe08eb30f433d = "plan";

});



parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});


parcelRegister("kZDjT", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $f981c975abc56594$export$3cf161fcd24b6b4f);

var $lE53e = parcelRequire("lE53e");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $k0ZZ2 = parcelRequire("k0ZZ2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f981c975abc56594$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
const $f981c975abc56594$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
    const { filterId: filterId, name: name } = (0, $8Uumt.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $lE53e.default), /* eslint-enable @atlassian/relay/unused-fields */ filter);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            ...customAnalytics || {},
            itemId: `filter-${filterId}`
        }), [
        customAnalytics,
        filterId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        key: filterId,
        analytics: analyticsAttributes,
        selectedOn: $f981c975abc56594$var$selectedOn,
        href: `${baseHref}?filter=${filterId}`
    }, name);
};

});
parcelRegister("lE53e", function(module, exports) {

$parcel$export(module.exports, "default", () => $251d70d9349441ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<331a8e20fbd9d2a81b2d41dfa21f3810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $251d70d9349441ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "filterItem_navigationAppsSidebarCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$251d70d9349441ea$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
var $251d70d9349441ea$export$2e2bcd8739ae039 = $251d70d9349441ea$var$node;

});


parcelRegister("4ABV3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f94c0f775539d45d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f94c0f775539d45d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    newStarredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
        "defaultMessage": "Starred filters"
    },
    viewAllStarredFilters: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.view-all-starred-filters",
        "defaultMessage": "View all starred filters"
    }
});

});


parcelRegister("3OGaE", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $09f1bcc415909488$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fJoTF = parcelRequire("fJoTF");
const $09f1bcc415909488$var$overrideStyles = null;
const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJoTF.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $bwpsq.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jSfqD = parcelRequire("jSfqD");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_vrjt140y _1cmdleuv _1w901jnk _14n4h2mm _1cg71wug _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_16hg1im0",
            item?.color?.default && "_1w901jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $jSfqD.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isTitleHeading: true
    }, children);
};

});


parcelRegister("juTur", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$bc7f6eebc16e6127);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $lpwtK = parcelRequire("lpwtK");

var $3d1up = parcelRequire("3d1up");
const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $3d1up.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $lpwtK.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("3d1up", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $2f6f53381b1f04e0$export$5b5545ed894dc47a);
const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


const $8218752389ec6194$export$d4cd258d01c03112 = 'global-issue-navigator';

parcelRegister("STfki", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f6a0f3cf25f8fbb3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f6a0f3cf25f8fbb3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    filtersHeader: {
        "id": "spa-apps-sidebar-filters.global-scope.menu.filters-header",
        "defaultMessage": "Filters"
    },
    viewAllFilters: {
        "id": "spa-apps-sidebar-filters.global-scope.menu.view-all-filters",
        "defaultMessage": "View all filters"
    },
    newSearch: {
        "id": "spa-apps-sidebar-filters.global-scope.menu.new-search",
        "defaultMessage": "New search"
    }
});

});

parcelRegister("5lItr", function(module, exports) {

$parcel$export(module.exports, "SystemFiltersSection", () => $0e18a9a558c22e0d$export$39397b84e354c1fb);

var $47bDC = parcelRequire("47bDC");

var $2HXRD = parcelRequire("2HXRD");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gjTBi = parcelRequire("gjTBi");

var $koVbs = parcelRequire("koVbs");

var $kZDjT = parcelRequire("kZDjT");

var $5gfdL = parcelRequire("5gfdL");
var $0e18a9a558c22e0d$var$_StyledSection = /*#__PURE__*/ (0, $47bDC.default)((0, $gjTBi.default)).withConfig({
    componentId: "sc-15wcfgs-0"
})`${(p)=>p._css}`;
const $0e18a9a558c22e0d$export$39397b84e354c1fb = ({ baseHref: baseHref, jiraQuery: jiraQuery, sectionCustomCss: sectionCustomCss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $2HXRD.default), jiraQuery);
    const systemFilterEdges = data.systemFilters?.edges || [];
    if (!systemFilterEdges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e18a9a558c22e0d$var$_StyledSection, {
        title: formatMessage((0, $5gfdL.messages).newDefaultFiltersHeader),
        _css: sectionCustomCss
    }, systemFilterEdges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZDjT.FilterItem), {
            key: edge.node.filterId,
            baseHref: baseHref,
            filter: edge.node
        }) : null));
};

});
parcelRegister("2HXRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f968c8b76d86b83b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdad03dfb3b463d9d8dd1b88570621b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f968c8b76d86b83b$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Literal",
                    "name": "isFavourite",
                    "value": false
                }
            ],
            "concreteType": "JiraSystemFilterConnection",
            "kind": "LinkedField",
            "name": "systemFilters",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSystemFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSystemFilter",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "filterId"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "filterItem_navigationAppsSidebarCommon"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$f968c8b76d86b83b$var$node.hash = "3a63b8dc9c67f2a7294ca62240142cfa";
var $f968c8b76d86b83b$export$2e2bcd8739ae039 = $f968c8b76d86b83b$var$node;

});

parcelRegister("5gfdL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $623b3f7db5626144$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $623b3f7db5626144$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    newDefaultFiltersHeader: {
        "id": "spa-apps-sidebar-filters.global-scope.menu.system-filters.new-default-filters-header",
        "defaultMessage": "Default filters"
    }
});

});





//# sourceMappingURL=async-sidebar-filters-global.35670cce.js.map
